<emperor-card-header
  class="pdf-header"
  [color]="EmperorCardHeaderColor.PRIMARY"
>
  {{ title }}
  <emperor-icon
    (click)="download()"
    name="data_download_9"
    class="header-icon push"
    role="button"
    tabindex="0"
    (keydown.enter)="download()"
    aria-label="Download"
  ></emperor-icon>
  <emperor-icon
    class="header-icon"
    name="close_1"
    emperorDialogClose
    role="button"
    tabindex="0"
    aria-label="Close dialog"
  ></emperor-icon>
</emperor-card-header>
<emperor-card-content [scrollable]="true" class="pdf-body">
  <article class="pdf-content">
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [show-borders]="true"
      [fit-to-page]="true"
      [original-size]="true"
      [external-link-target]="'blank'"
      style="width: 100%; height: 100%"
    ></pdf-viewer>
  </article>
</emperor-card-content>
